import PageSection from '@/components/PageSection';
import Button, { ButtonVariant } from '@/components/Button';
import { localizeDate } from 'components/LocalizedDate';
import useScreenSize from 'hooks/useScreenSize';
import Close from 'icons/Close';
import { usePhotoGalleryContainer } from '..';
import styles from './styles/PhotoGalleryHeader.module.scss';
import { useApplicationContainer } from 'containers/ApplicationContainer';
import Image from 'components/Image';
import Link from 'components/Link';

export default function PhotoGalleryHeader() {
  const [, { getBackPath }] = useApplicationContainer();
  const [{ photoGallery }] = usePhotoGalleryContainer();
  const { isSmallScreen } = useScreenSize();

  return (
    <div className={styles.HeaderContainer}>
      <PageSection>
        <div className={styles.HeaderContent}>
          <div className={styles.HeaderTeams}>
            {photoGallery.teams.map((team, index) => {
              return (
                <Link key={team.id} href={team.webPath}>
                  <div className={styles.HeaderText}>
                    {index === 1 && photoGallery.teams.length === 2 && <div className={styles.VersusText}>vs</div>}
                    <Image src={team.image} alt={`${team.name} icon`} className={styles.TeamLogo} />
                    <div className={styles.TeamText}>{isSmallScreen ? team.abbrev : team.name}</div>
                  </div>
                </Link>
              );
            })}
          </div>
          {!isSmallScreen && (
            <div className={styles.DateContainer}>
              <div className={styles.Dot}></div>
              <div className={styles.DateText}>{localizeDate(photoGallery.date, 'MMMM DD, YYYY')}</div>
            </div>
          )}
          <Button href={getBackPath('/')} className={styles.CloseButton} variant={ButtonVariant.WHITE}>
            <Close color="#000000" height={11} width={11} /> Close
          </Button>
        </div>
      </PageSection>
    </div>
  );
}
